import { UseMultipleChartsType } from '@ecosystem/export-utils';
import { Dispatch, SetStateAction, createContext, useContext } from 'react';

export interface MultiStackedChartExportType {
  chartRefsIsInitialisedStatus: boolean[];
  multipleExportCallbacks: UseMultipleChartsType;
  setChartRefsIsInitialisedStatus: Dispatch<SetStateAction<boolean[]>>;
  setMultipleExportCallbacks: Dispatch<SetStateAction<UseMultipleChartsType>>;
}

export const MultiStackedChartExportContext = createContext<MultiStackedChartExportType>(
  {} as MultiStackedChartExportType,
);

export const useMultiStackedChartExport = (): MultiStackedChartExportType =>
  useContext<MultiStackedChartExportType>(MultiStackedChartExportContext);
